var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24919 13.139H0.998756C0.722769 13.139 0.5 12.9296 0.5 12.6702V0.468727C0.5 0.209357 0.722784 0 0.998756 0H8.24919C8.52518 0 8.74795 0.209371 8.74795 0.468727V12.6702C8.74795 12.9281 8.52516 13.139 8.24919 13.139ZM1.49744 12.2015H7.75015V0.937621H1.49744V12.2015Z",
    fill: "url(#paint0_linear_2173_8636)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24919 30.0002H0.998756C0.722769 30.0002 0.5 29.7908 0.5 29.5314V20.9282C0.5 20.6688 0.722784 20.4595 0.998756 20.4595H8.24919C8.52518 20.4595 8.74795 20.6688 8.74795 20.9282V29.5314C8.74795 29.7908 8.52516 30.0002 8.24919 30.0002ZM1.49744 29.0627H7.75015V21.3971H1.49744V29.0627Z",
    fill: "url(#paint1_linear_2173_8636)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9992 30.0002H22.7488C22.4728 30.0002 22.25 29.7908 22.25 29.5314V20.9282C22.25 20.6688 22.4728 20.4595 22.7488 20.4595H29.9992C30.2752 20.4595 30.4979 20.6688 30.4979 20.9282L30.4996 29.5314C30.4979 29.7908 30.2752 30.0002 29.9992 30.0002ZM23.2474 29.0627H29.5002V21.3971H23.2474V29.0627Z",
    fill: "url(#paint2_linear_2173_8636)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7496 30.0002H8.24876C7.97277 30.0002 7.75 29.7908 7.75 29.5314V20.9282C7.75 20.6688 7.97278 20.4595 8.24876 20.4595H22.7496C23.0256 20.4595 23.2484 20.6688 23.2484 20.9282V29.5314C23.2484 29.7908 23.0239 30.0002 22.7496 30.0002ZM8.74744 29.0627H22.2509V21.3971H8.74744V29.0627Z",
    fill: "url(#paint3_linear_2173_8636)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4992 7.39071H8.24876C7.97277 7.39071 7.75 7.18134 7.75 6.92198V0.468727C7.75 0.209357 7.97278 0 8.24876 0H15.4992C15.7752 0 15.9979 0.209371 15.9979 0.468727V6.92198C15.9979 7.17979 15.7752 7.39071 15.4992 7.39071ZM8.74744 6.45322H15.0002V0.937621H8.74744V6.45322Z",
    fill: "url(#paint4_linear_2173_8636)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7492 7.39071H15.4988C15.2228 7.39071 15 7.18134 15 6.92198V0.468727C15 0.209357 15.2228 0 15.4988 0H22.7492C23.0252 0 23.2479 0.209371 23.2479 0.468727V6.92198C23.2479 7.17979 23.0235 7.39071 22.7492 7.39071ZM15.9974 6.45322H22.2502V0.937621H15.9974V6.45322Z",
    fill: "url(#paint5_linear_2173_8636)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9992 13.139H22.7488C22.4728 13.139 22.25 12.9296 22.25 12.6702V0.468727C22.25 0.209357 22.4728 0 22.7488 0H29.9992C30.2752 0 30.4979 0.209371 30.4979 0.468727V12.6702C30.4979 12.9281 30.2752 13.139 29.9992 13.139ZM23.2474 12.2015H29.5002L29.5018 0.937622H23.2491L23.2474 12.2015Z",
    fill: "url(#paint6_linear_2173_8636)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0049 13.1395H9.99876C9.72277 13.1395 9.5 12.9301 9.5 12.6708V11.5005C9.5 11.2411 9.72278 11.0317 9.99876 11.0317H21.0049C21.2809 11.0317 21.5037 11.2411 21.5037 11.5005V12.6708C21.5037 12.9286 21.2792 13.1395 21.0049 13.1395ZM10.4971 12.202H20.5059V11.9692H10.4971V12.202Z",
    fill: "url(#paint7_linear_2173_8636)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0813 9.58634H12.9206C12.6446 9.58634 12.4219 9.37697 12.4219 9.11761V6.92234C12.4219 6.66297 12.6447 6.45361 12.9206 6.45361C13.1966 6.45361 13.4194 6.66298 13.4194 6.92234V8.64889H17.5841V6.92234C17.5841 6.66297 17.8069 6.45361 18.0828 6.45361C18.3588 6.45361 18.5816 6.66298 18.5816 6.92234V9.11761C18.5799 9.37698 18.3588 9.58634 18.0812 9.58634H18.0813Z",
    fill: "url(#paint8_linear_2173_8636)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6787 11.9676C19.5124 11.9676 19.3495 11.8895 19.2564 11.7489L17.8066 9.58642H13.1911L11.7414 11.7489C11.5934 11.9676 11.2858 12.0333 11.0531 11.8958C10.8203 11.7567 10.7505 11.4676 10.8968 11.2489L12.4962 8.86767C12.5876 8.73017 12.7473 8.64893 12.9185 8.64893H18.0827C18.2523 8.64893 18.4135 8.73017 18.505 8.86767L20.101 11.2489C20.249 11.4677 20.1775 11.7567 19.9448 11.8958C19.8616 11.9442 19.7702 11.9676 19.6787 11.9676L19.6787 11.9676Z",
    fill: "url(#paint9_linear_2173_8636)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0318 28.6164H10.9675C10.6915 28.6164 10.4688 28.407 10.4688 28.1477V23.9477C10.4688 23.6884 10.6915 23.479 10.9675 23.479H20.0318C20.3078 23.479 20.5305 23.6884 20.5305 23.9477V28.1477C20.5305 28.4055 20.3061 28.6164 20.0318 28.6164ZM11.4662 27.6789H19.5331V24.4165H11.4662V27.6789Z",
    fill: "url(#paint10_linear_2173_8636)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1617 25.7163H12.8347C12.5587 25.7163 12.3359 25.5069 12.3359 25.2475C12.3359 24.9882 12.5587 24.7788 12.8347 24.7788H18.1635C18.4394 24.7788 18.6622 24.9882 18.6622 25.2475C18.6605 25.5069 18.4394 25.7163 18.1618 25.7163H18.1617Z",
    fill: "url(#paint11_linear_2173_8636)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7496 23.0317H8.24876C7.97277 23.0317 7.75 22.8223 7.75 22.563C7.75 22.3036 7.97278 22.0942 8.24876 22.0942H22.7496C23.0256 22.0942 23.2484 22.3036 23.2484 22.563C23.2484 22.8223 23.0239 23.0317 22.7496 23.0317Z",
    fill: "url(#paint12_linear_2173_8636)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25046 21.3964H3.51047C3.23449 21.3964 3.01172 21.1871 3.01172 20.9277V19.7246C3.01172 19.4652 3.2345 19.2559 3.51047 19.2559H8.25224C8.52822 19.2559 8.75099 19.4652 8.75099 19.7246V20.9277C8.74933 21.1855 8.52655 21.3964 8.25057 21.3964H8.25046ZM4.00916 20.4589H7.7532V20.1933H4.00916V20.4589Z",
    fill: "url(#paint13_linear_2173_8636)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51047 20.1942C3.23449 20.1942 3.01172 19.9848 3.01172 19.7254V16.7099C3.01172 15.9224 3.69338 15.2817 4.53132 15.2817C5.36926 15.2817 6.05093 15.9224 6.05093 16.7099C6.05093 16.9692 5.82815 17.1786 5.55217 17.1786C5.2762 17.1786 5.05342 16.9692 5.05342 16.7099C5.05342 16.4411 4.81899 16.2192 4.53136 16.2192C4.24373 16.2192 4.0093 16.4395 4.0093 16.7099V19.7254C4.0093 19.9833 3.78319 20.1942 3.51054 20.1942H3.51047Z",
    fill: "url(#paint14_linear_2173_8636)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6706 21.3964C12.3946 21.3964 12.1719 21.1871 12.1719 20.9277V19.7246C12.1719 19.4652 12.3947 19.2559 12.6706 19.2559H13.6033C13.8793 19.2559 14.1021 19.4652 14.1021 19.7246C14.1021 19.9839 13.8793 20.1933 13.6033 20.1933H13.1694V20.9277C13.1694 21.1855 12.945 21.3964 12.6707 21.3964L12.6706 21.3964Z",
    fill: "url(#paint15_linear_2173_8636)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3299 21.3964C18.0539 21.3964 17.8311 21.187 17.8311 20.9277V20.1933H17.3972C17.1212 20.1933 16.8984 19.9839 16.8984 19.7246C16.8984 19.4652 17.1212 19.2559 17.3972 19.2559H18.3299C18.6059 19.2559 18.8287 19.4652 18.8287 19.7246V20.9277C18.8287 21.1855 18.6075 21.3964 18.3299 21.3964L18.3299 21.3964Z",
    fill: "url(#paint16_linear_2173_8636)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4988 21.3964C15.2228 21.3964 15 21.1871 15 20.9277V19.7246C15 19.4652 15.2228 19.2559 15.4988 19.2559C15.7747 19.2559 15.9975 19.4652 15.9975 19.7246V20.9277C15.9975 21.1855 15.7747 21.3964 15.4988 21.3964Z",
    fill: "url(#paint17_linear_2173_8636)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3347 26.5372C24.0587 26.5372 23.8359 26.3279 23.8359 26.0685V24.3935C23.8359 24.1342 24.0587 23.9248 24.3347 23.9248C24.6107 23.9248 24.8334 24.1342 24.8334 24.3935V26.0685C24.8334 26.3263 24.609 26.5372 24.3347 26.5372Z",
    fill: "url(#paint18_linear_2173_8636)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66282 26.5372C6.38683 26.5372 6.16406 26.3279 6.16406 26.0685V24.3935C6.16406 24.1342 6.38685 23.9248 6.66282 23.9248C6.93879 23.9248 7.16157 24.1342 7.16157 24.3935V26.0685C7.16157 26.3263 6.94045 26.5372 6.66282 26.5372Z",
    fill: "url(#paint19_linear_2173_8636)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9992 7.03755H22.7488C22.4728 7.03755 22.25 6.82818 22.25 6.56882C22.25 6.30947 22.4728 6.1001 22.7488 6.1001H29.9992C30.2752 6.1001 30.4979 6.30947 30.4979 6.56882C30.4996 6.82819 30.2752 7.03755 29.9992 7.03755Z",
    fill: "url(#paint20_linear_2173_8636)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24919 7.03755H0.998756C0.722769 7.03755 0.5 6.82818 0.5 6.56882C0.5 6.30947 0.722784 6.1001 0.998756 6.1001H8.24919C8.52518 6.1001 8.74795 6.30947 8.74795 6.56882C8.74795 6.82818 8.52516 7.03755 8.24919 7.03755Z",
    fill: "url(#paint21_linear_2173_8636)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9792 5.71285H25.7722C25.4962 5.71285 25.2734 5.50348 25.2734 5.24412C25.2734 4.98476 25.4962 4.77539 25.7722 4.77539H26.9792C27.2552 4.77539 27.478 4.98476 27.478 5.24412C27.478 5.50348 27.2552 5.71285 26.9792 5.71285Z",
    fill: "url(#paint22_linear_2173_8636)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9792 11.8071H25.7722C25.4962 11.8071 25.2734 11.5977 25.2734 11.3384C25.2734 11.079 25.4962 10.8696 25.7722 10.8696H26.9792C27.2552 10.8696 27.478 11.079 27.478 11.3384C27.478 11.5977 27.2552 11.8071 26.9792 11.8071Z",
    fill: "url(#paint23_linear_2173_8636)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22531 5.71285H4.01829C3.7423 5.71285 3.51953 5.50348 3.51953 5.24412C3.51953 4.98476 3.74232 4.77539 4.01829 4.77539H5.22531C5.5013 4.77539 5.72407 4.98476 5.72407 5.24412C5.72407 5.50348 5.50294 5.71285 5.22531 5.71285Z",
    fill: "url(#paint24_linear_2173_8636)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22531 11.8071H4.01829C3.7423 11.8071 3.51953 11.5977 3.51953 11.3384C3.51953 11.079 3.74232 10.8696 4.01829 10.8696H5.22531C5.5013 10.8696 5.72407 11.079 5.72407 11.3384C5.72407 11.5977 5.50294 11.8071 5.22531 11.8071Z",
    fill: "url(#paint25_linear_2173_8636)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8191 4.74124C13.5431 4.74124 13.3203 4.53187 13.3203 4.27252V3.32566C13.3203 3.06629 13.5431 2.85693 13.8191 2.85693C14.095 2.85693 14.3178 3.0663 14.3178 3.32566V4.27252C14.3178 4.53189 14.095 4.74124 13.8191 4.74124Z",
    fill: "url(#paint26_linear_2173_8636)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1823 4.74124C16.9064 4.74124 16.6836 4.53187 16.6836 4.27252V3.32566C16.6836 3.06629 16.9064 2.85693 17.1823 2.85693C17.4583 2.85693 17.6811 3.0663 17.6811 3.32566V4.27252C17.6811 4.53189 17.4583 4.74124 17.1823 4.74124Z",
    fill: "url(#paint27_linear_2173_8636)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_8636",
    x1: 0.5,
    y1: 6.56948,
    x2: 8.74795,
    y2: 6.56948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2173_8636",
    x1: 0.5,
    y1: 25.2298,
    x2: 8.74795,
    y2: 25.2298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2173_8636",
    x1: 22.25,
    y1: 25.2298,
    x2: 30.4996,
    y2: 25.2298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2173_8636",
    x1: 7.75,
    y1: 25.2298,
    x2: 23.2484,
    y2: 25.2298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2173_8636",
    x1: 7.75,
    y1: 3.69535,
    x2: 15.9979,
    y2: 3.69535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2173_8636",
    x1: 15,
    y1: 3.69535,
    x2: 23.2479,
    y2: 3.69535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2173_8636",
    x1: 22.25,
    y1: 6.56948,
    x2: 30.4979,
    y2: 6.56948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2173_8636",
    x1: 9.5,
    y1: 12.0856,
    x2: 21.5037,
    y2: 12.0856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2173_8636",
    x1: 12.4219,
    y1: 8.01998,
    x2: 18.5816,
    y2: 8.01998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2173_8636",
    x1: 10.8203,
    y1: 10.3083,
    x2: 20.1783,
    y2: 10.3083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2173_8636",
    x1: 10.4688,
    y1: 26.0477,
    x2: 20.5305,
    y2: 26.0477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2173_8636",
    x1: 12.3359,
    y1: 25.2475,
    x2: 18.6622,
    y2: 25.2475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2173_8636",
    x1: 7.75,
    y1: 22.563,
    x2: 23.2484,
    y2: 22.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2173_8636",
    x1: 3.01172,
    y1: 20.3261,
    x2: 8.75099,
    y2: 20.3261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2173_8636",
    x1: 3.01172,
    y1: 17.738,
    x2: 6.05093,
    y2: 17.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2173_8636",
    x1: 12.1719,
    y1: 20.3261,
    x2: 14.1021,
    y2: 20.3261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2173_8636",
    x1: 16.8984,
    y1: 20.3261,
    x2: 18.8287,
    y2: 20.3261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2173_8636",
    x1: 15,
    y1: 20.3261,
    x2: 15.9975,
    y2: 20.3261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2173_8636",
    x1: 23.8359,
    y1: 25.231,
    x2: 24.8334,
    y2: 25.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2173_8636",
    x1: 6.16406,
    y1: 25.231,
    x2: 7.16157,
    y2: 25.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2173_8636",
    x1: 22.25,
    y1: 6.56882,
    x2: 30.498,
    y2: 6.56882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2173_8636",
    x1: 0.5,
    y1: 6.56882,
    x2: 8.74795,
    y2: 6.56882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2173_8636",
    x1: 25.2734,
    y1: 5.24412,
    x2: 27.478,
    y2: 5.24412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2173_8636",
    x1: 25.2734,
    y1: 11.3384,
    x2: 27.478,
    y2: 11.3384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2173_8636",
    x1: 3.51953,
    y1: 5.24412,
    x2: 5.72407,
    y2: 5.24412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2173_8636",
    x1: 3.51953,
    y1: 11.3384,
    x2: 5.72407,
    y2: 11.3384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2173_8636",
    x1: 13.3203,
    y1: 3.79909,
    x2: 14.3178,
    y2: 3.79909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2173_8636",
    x1: 16.6836,
    y1: 3.79909,
    x2: 17.6811,
    y2: 3.79909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/Kitchen.f459848314afbdd98257d8d316880737.svg";
export { ForwardRef as ReactComponent };